module.exports = __webpack_public_path__ + "static/lato-latin-700.bf047072.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-lato/files/lato-latin-700.woff
// module id = ./node_modules/typeface-lato/files/lato-latin-700.woff
// module chunks = 17241999800008180000